import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucQuyTrinhSanXuat } from 'src/app/shared/DanhMucQuyTrinhSanXuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucQuyTrinhSanXuatService extends BaseService{

    displayColumns001: string[] = ['STT', 'ID', 'ParentID', 'Name', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucQuyTrinhSanXuat";
    }
}

